<template>
  <div id="pdf" class="container-fluid">
    <div id="rowcicle" v-for="(value, key) in grouped" :key="key">
      <div id="rowlogos">
        <img id="leak" class="logo_leak" width="200px" :src="logoUrl">
      </div>
      <h4 id="h41">{{ header }}</h4>
      <hr id="hr1" class="yellow__hr" />
      <div id="pdf_info" class="pdf__info">
        <p> <span id="titles" class="pdf__titles"> Estación: </span> {{ key }} </p>
        <p> <span id="titles" class="pdf__titles"> Ducto: </span> {{ duct }} </p>
        <div id="tablecontainer">
          <table id="tableholder">
            <thead id="header">
              <tr id="trh">
                <th id="thh" class="title__td">Fecha de Solicitud</th>
                <th id="thh" class="title__td">Mensaje</th>
                <th id="thh" class="title__td">Fecha de Recepción</th>
                <th id="thh" class="title__td">Presión</th>
                <th v-if="showViewColumn === 'true'" id="thh" class="title__td print-hidden"></th>
              </tr>
            </thead>
            <tbody>
              <tr id="trw" v-for="a in value" :class="{ 'highlight': a.samePressure }">
                <td id="tdc"> {{ a.r_ts }} </td>
                <td id="tdc"> {{ a.r_f }} </td>
                <td id="tdc"> {{ a.i_ts }} </td>
                <td id="tdc"><span :class="{ 'highlight': a.samePressure }"> {{ a.p }} </span></td>
                <td v-if="showViewColumn === 'true'" class="print-hidden">
                  <div class="center-option">
                    <i @click="open(a)" class="fa fa-eye" aria-hidden="true" title="Ver detalles"></i>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div :id="'imgChart-' + filterLettersAndNumbers(key)" class="bottom-offset"></div>
        <div id="linechart" :class="{'hide-line-chart' : isChartDisplayed }">
          <line-chart style="opacity:0.0" :class="filterLettersAndNumbers(key)" @onAnimationComplete="onAnimationComplete"
            :chartData="getChartDataFromSite({ key: key, value: value })" :options="chartOptions" :width="300"
            :height="200">
          </line-chart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LineChart from 'components/Charts/LineChartImp.js'
import groupBy from 'lodash/groupBy'

export default {
  'line-chart': LineChart,
  data() {
    return {
      isChartDisplayed: false,
      click: false,
      grouped: [],
      datachart: null,
      data_preassure: [],
      DataPoll: null,
      chartOptions: {
        animation: false,
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            beginAtZero: false // Ensure the Y-axis doesn't start from zero
          }
        }
      }
    }
  },
  props: ['duct', 'site', 'desde', 'hasta', 'header', 'showViewColumn', 'chartLimit', 'isDetails', 'datetimeTag'],
  components: {
    LineChart
  },
  computed: {
    logoUrl() {
      return require('imgs/logos/Logo_' + process.env.SITE_TYPE + '_V.png');
    }
  },
  methods: {
    onAnimationComplete() {
      this.isChartDisplayed = true;
    },
    open(data) {
      this.$emit('openDetails', data);
    },
    orderbystations() {
      var full = this.site
      this.grouped = groupBy(full, function (x) {
        return x.namestation
      })
    },
    filterLettersAndNumbers(input) {
      let tag = input;
      if (this.datetimeTag) {
        tag += '_' + this.datetimeTag;
      }
      return tag.toLowerCase().replace(/[^a-zA-Z0-9]/g, '');
    },
    getChartDataFromSite(options) {
      const value = options.value
      const key = options.key
      const colorlist = '#e74c3c'
      const data = [];
      const labels = [];
      const limit = parseInt(this.chartLimit);
      let startTime = null;
      if (this.datetimeTag) {
        startTime = new Date(this.datetimeTag.replace(/-/g, ' '));
      }

      for (let i = 0; i < limit; i++) {
        let record = value.find(val => val.h == i);
        const pressure = (record && record.p) ? record.p : null;
        if (startTime) {
          const newTime = new Date(startTime);
          newTime.setMinutes(newTime.getMinutes() + (i * 10));
          const formattedTime = newTime.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
          });
          labels.push(formattedTime);
        } else {
          labels.push(i.toString().padStart(2, '0') + ':50');
        }
        data.push(pressure);
      }

      const datasets = [
        {
          label: key,
          data: data,
          backgroundColor: colorlist,
          borderColor: colorlist,
          borderWidth: 1,
          pointBorderWidth: 1,
          fill: false,
          pointRadius: 0
        }
      ];
      let chartData = {
        labels: labels,
        datasets: datasets
      };

      setTimeout(() => {
        let siteClass = this.filterLettersAndNumbers(key)
        let canvasEle = document.querySelector('.' + siteClass + ' #line-chart')
        canvasEle = canvasEle.toDataURL()
        let imgC = document.createElement('img')
        imgC.id = 'chartImg' + siteClass
        imgC.src = canvasEle
        imgC.style = 'width:100%;'
        document.querySelector('#imgChart-' + siteClass).innerHTML = ''
        document.querySelector('#imgChart-' + siteClass).appendChild(imgC)
        this.$store.state.cclick = false
      }, 500)
      return chartData;
    },
    getChartOptions() {
      let options = Object.assign({}, this.chartOptions);
      return options
    }
  },
  watch: {
    site() {
      this.grouped = this.site
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~varmix';

.bottom-offset {
  margin-bottom: 20px;
}

.hide-line-chart {
  display: none;
}

.highlight {
  color: red;
}

td {

  i {
    color: $inactive;
    cursor: pointer;

    &:hover {
      color: $amarilloC;
    }
  }

  .center-option {
    display: flex;
    justify-content: center;
  }
}

#pdf {
  width: 100%;

  .logo_leak {
    width: 150px;
    text-align: left;
  }

  .logo_pem {
    width: 150px;
    float: right;
  }

  #row {
    padding: 25px;
  }

  img {
    width: 100%;
  }

  hr {
    color: var(--btn-default);
  }

  table {
    width: 100%;
  }

  .title__td {
    background-color: $amarilloC;
    border: 0px solid $gray;
    color: white;
  }

  th {
    padding: 10px;
  }

  td {
    padding: 5px;
    border: 1px solid $gray;
  }

  #imgChart {
    width: 100%;
    margin-top: 100px;
  }

  h4 {
    text-align: left;
    text-transform: uppercase;
    color: #666;
  }

  .pdf__info {
    margin: 0 auto;
    display: block;
  }

  p {
    color: #666;
  }

  .pdf__titles {
    color: var(--btn-default);
  }

  .yellow__hr {
    background-color: $amarilloC;
    height: 2px;
  }
}

#pagebreak {
  display: block;
  page-break-after: always;
}
</style>



// WEBPACK FOOTER //
// PdfDiv.vue?19b75592